import React, {Component} from 'react';
import './home_square.scss';
import HomePageCard1 from "../home_square/home_page_card_1/Home_Page_Card_1";
import HomePageCard2 from "../home_square/home_page_card_2/Home_Page_Card_2";
import HomePageCard3 from "../home_square/home_page_card_3/Home_Page_Card_3";
import HomePageCard4 from "../home_square/home_page_card_4/Home_Page_Card_4";
import HomePageCard5 from "../home_square/home_page_card_5/Home_Page_Card_5";
import HomePageCard6 from "../home_square/home_page_card_6/Home_Page_Card_6";

class HomeSquare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cards: []
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props.content !== nextProps.content;
    }

    render() {

        switch (this.props.content.type) {
            case '':
                return <HomePageCard1 {...this.props}/>;
            case 'type1':
                return <HomePageCard3 {...this.props} />;
            case 'type2':
                return <HomePageCard2 {...this.props} />;
            case 'type3':
                return <HomePageCard4 {...this.props} />;
            case 'type4':
                return <HomePageCard5 {...this.props} />;
            case 'type5':
                return <HomePageCard6 {...this.props} />;
            default:
                return null;
        }
    }
}

export default HomeSquare;
